export type CreditRunwayTone = 'red' | 'orange' | 'green' | 'neutral';

export type CreditRunwayKind = 'noUse' | 'overYear' | 'days';

export type CreditRunway =
  | { kind: Extract<CreditRunwayKind, 'noUse'>; tone: CreditRunwayTone; days: null; runsOutOn: null }
  | { kind: Exclude<CreditRunwayKind, 'noUse'>; tone: CreditRunwayTone; days: number; runsOutOn: Date };

const RED_BELOW_DAYS = 30;
const ORANGE_BELOW_DAYS = 120;
const OVER_A_YEAR_DAYS = 365;

export function describeCreditRunway(daysRemaining: number | null, today: Date): CreditRunway {
  if (daysRemaining === null) {
    return { kind: 'noUse', tone: 'neutral', days: null, runsOutOn: null };
  }
  const runsOutOn = new Date(today.getFullYear(), today.getMonth(), today.getDate() + daysRemaining);
  if (daysRemaining > OVER_A_YEAR_DAYS) {
    return { kind: 'overYear', tone: 'green', days: daysRemaining, runsOutOn };
  }
  const tone: CreditRunwayTone = daysRemaining < RED_BELOW_DAYS ? 'red' : daysRemaining < ORANGE_BELOW_DAYS ? 'orange' : 'green';
  return { kind: 'days', tone, days: daysRemaining, runsOutOn };
}
